
import React from 'react';
import * as classes from './CustomTableBox.module.scss';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import { getIconsForData } from "Flow2/components/CustomCollections/CustomDataControllers/CustomMediaController";
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CustomTableHeaderIcon = (props) => {
    let icon = null;
    let data = props.data || "";
    if (props.dataId)
        icon = getIconsForData(props.dataId);
    else
        icon = getIconsForData(data.toLowerCase());

    if (icon) return <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} />
    else return <div />

}

/*
 * TABLE: MEDIAFILES
 */

export const MediaFilesData = [
    [{ ID: "type", DE: "Typ", EN: "Type", RU: "Тип" }],
    [{ ID: "id", DE: "Datei ID", EN: "File ID", RU: "Идентификатор файла" }],
    [{ ID: "language", DE: "Sprachen", EN: "Language", RU: "Язык" }],
    [{ ID: "subtitle", DE: "Untertitel", EN: "Subtitle", RU: "Субтитров" }],
    [{ ID: "resolution", DE: "Auflösung", EN: "Resolution", RU: "Разрешение" }],
    [{ ID: "filesize", DE: "Größe", EN: "Size", RU: "Размер" }],
    [{ ID: "aspectratio", DE: "Verhältnis/  Datenrate", EN: "Aspect Ratio/  Datarate", RU: "Соотношение аспектов/ Дата-трата данных" }],
    [{ ID: "format", DE: "Format/ VideoCodec/ AudioCodec", EN: "Format/ VideoCodec/ AudioCodec", RU: "Формат/ ВидеоКодк/ АудиоКод" }],
    [{ ID: "purpose", DE: "Verwendung", EN: "Purpose", RU: "Цель" }],
]

export const CustomTableMf = (props) => {
    return (
        <div className={classes.CustomTableMfContainer}>
            {props.children}
        </div>
    )
}

export const CustomTableMfHeader = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);
    return (
        <div className={classes.CustomTableMfHeaderContainer}>
            <div className={classes.CustomTableMfHeaderRow}>
                {data.map(item => {
                    let name = item[0].ID;
                    let icon = setMfSortIcon(props.sortMfObj[`is${name}Sorted`], name);
                    return (
                        <div className={classes[getMfHeaderClass(name)]}>
                            {
                                mfSort(name) ?
                                    <div className={classes.CustomTableMfSortBox}>
                                        {DataUtil.writeName(item[0][lg])}
                                        {
                                            mfSort(name) ? <div className={classes.CustomTableMfSortIconRound} onClick={() => { props.onSortClick(name); }} ><FontAwesomeIcon className={classes.CustomTableSortIcon}
                                                icon={icon} /></div> : null
                                        }
                                    </div>
                                    : <CustomTableMfField name={name}>{DataUtil.writeName(item[0][lg])}</CustomTableMfField>
                            }
                        </div>);
                })
                }
                <div className={classes.CustomTableMfHeaderButton}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export const CustomTableMfBody = (props) => {
    return (
        <div className={classes.CustomTableMfBodySection}>
            {props.children}
        </div>
    )
}

export const CustomTableMfField = (props) => {
    if (props.name === "type")
        return (<div>
            <FontAwesomeIcon style={{ marginRight: '10px' }} icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faLaptop")} />
            {props.children}
        </div >)

    return <div>{props.children}</div>
}

export const showTableMfInfo = (data, language) => {
    let lg = DataUtil.getLanguage(language);
    const elementStyle = '<div style="border:1px solid #f7f7f7; border-top: none; font-size: 12px; color: #aaaaaa; text-align:left; padding: 2px;">';
    const divStyle = '<div style="border-top:1px solid #f7f7f7;">';
    const textStyle = '<span style="color: black;">';
    let infos = data.reduce((acc, item) => {
        acc = acc + elementStyle + textStyle + DataUtil.writeName(DataUtil.translateMessageForApp(item[0], lg)) + '</span>' + ' : ' + item[1] + '</div>';
        return acc;
    }, '');

    return (divStyle + infos + '</div>')
}


export const convertMfInfo = (obj, term) => {
    let data = null;
    if (obj && obj.props && obj.props.children)
        data = obj.props.children;
    if (data) {
        let tmp1 = DataUtil.subStringAfter(data, "|");
        let tmp2 = DataUtil.subStringAfter(tmp1, "|");
        switch (term) {
            case "resolution":
                return DataUtil.subStringBefore(data, "|");
            case "filesize":
                return DataUtil.subStringBefore(tmp1, "|");
            case "aspectratio":
                return DataUtil.subStringBefore(tmp2, "|");
            case "format":
                return DataUtil.subStringAfter(tmp2, "|");
        }
    }
    return "-";
}


export const getMfHeaderClass = (data) => {
    let className;
    switch (data) {
        case 'language':
            className = "CustomTableMfColumnFixed";
            break;
        case 'subtitle':
        case 'purpose':
            className = "CustomTableMfColumnSecondary";
            break;
        case 'type':
            className = "CustomTableMfColumnPrimary";
            break;
        default:
            className = "CustomTableMfColumn";
            break;
    }
    return className;
}

export const mfSort = (data) => {
    if (data === CustomTypes.ID) return true;
    return false;
}

export const getMfSortedData = (data, name, sorted) => {
    let sortParams;
    let sortedMfiles = [];

    try {
        let convertedData = DataUtil.convertObjectKeyData(data);
        if (name === CustomTypes.ID || name === 'filesize') {
            sortParams = sorted ? { prop: name } : { prop: name, desc: true };
            return sortedMfiles = DataUtil.sortByProperty(convertedData, sortParams);

        } else {
            sortParams = sorted ? "" : "-";
            if (name === "type") sortParams = sortParams + "filename";
            else sortParams = sortParams + name;

            return sortedMfiles = convertedData.sort(DataUtil.dynamicSortAndIgnoreCase(sortParams));
        }
    } catch (error) {
        console.log("LAMTEST getMfSortedData");
        return data;
    }
}

export const setMfInitState = (data) => {
    let initData = { ...data };
    for (let i in initData) {
        if (initData[i]) initData[i] = false;
    }

    return initData;
}

export const setMfSortIcon = (data, name) => {
    let faChevronDown = CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faChevronDown");
    let faChevronUp = CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faChevronUp");
    let icon = faChevronDown
    if (data) icon = faChevronUp;
    if (name === CustomTypes.ID) {
        if (data) icon = faChevronDown;
        else icon = faChevronUp;
    }
    return icon;
}

/**
 * TABLE: CLIPLIST_LIST
 */
export const getHeaderDataForTable = () => {
    let headerData = [
        [{ ID: "thumbnail", DE: "Vorschaugrafik", EN: "Thumbnail", RU: "Миниатюру" }],
        [{ ID: "title", DE: "Titel/ Länge/ Größe", EN: "Title/ Duration/ Size", RU: "Название/ Длина/ размер" }],
        [{ ID: "uploaddate", DE: "Uploaddatum", EN: "Upload Date", RU: "Дата загрузки" }],
        [{ ID: "status", DE: "Status/ Rechte", EN: "Status/ Rights", RU: "Статус/права" }],
        [{ ID: "resolution", DE: "Auflösung/ Format", EN: "Resolution/ Format", RU: "Резолюция/Формат" }],
        [{ ID: "videolanguages", DE: "Sprachversionen", EN: "Video Languages", RU: "Языки" }],
        [{ ID: "actions", DE: "Aktionen", EN: "Actions", RU: "Действия" }],
    ]

    return headerData;
}

export const getClassName = (data) => {
    let className;
    switch (data) {
        case CustomTypes.THUMB:
            className = "CustomTableColumnThumb";
            break;
        case CustomTypes.TITLE:
            className = "CustomTableColumnTitle";
            break;
        case CustomTypes.STATUS:
            className = "CustomTableColumnStatus";
            break;
        default:
            className = "CustomTableColumn";
            break;
    }

    return className;
}

export const CustomClipsTableHeader = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);

    return (
        <div className={classes.CustomTableHeaderContainer}>
            <div className={classes.CustomTableHeaderRow}>
                {data.map(item => <div className={classes[getClassName(item[0].ID)]}>{props.noIcon ? <div /> : <CustomTableHeaderIcon dataId={item[0].ID} data={item[0][lg]} />}{DataUtil.writeName(item[0][lg])}</div>)}
            </div>
        </div>
    )
}

export const CustomTableLargeTitle = (props) => {
    return (<div className={classes.CustomTableBodyColumnContainer}>
        <div className={classes.CustomTableTitleBox}>
            <div className={classes.CustomTableTitleText} data-text={props.data}>
                <input type="text" value={props.data} />
            </div>
        </div>
    </div>)
}


/*
* TABLE: HISTORY
*/


export const CustomTableHeader = (props) => {
    let data = props.data;

    return (
        <div className={classes.TableSubRow}>
            {data.map(item => <div className={classes.TableDataHeader}>{props.noIcon ? <div /> : <CustomTableHeaderIcon data={item[0]} />}{props.isLang ? <FormattedMessage id={`customdata.history.${item[0]}`} /> : DataUtil.writeName(item[0])}</div>)}
        </div>
    )
}

export const CustomTableWithHeaderRow = (props) => {
    let data = props.data;
    return (
        <div>
            {(props.isFirst) ? <CustomTableHeader isLang={props.isLang} isFirst={props.isFirst} data={props.data} /> : <div />}
            <div className={classes.TableRow}>
                {data.map((item) => <div className={classes.TableColumn}><div className={classes.TableSubRow}> <div className={classes.TableDataContent}>{(props.isLang && item[0] === "action" && item[1] !== "") ? <FormattedMessage id={`customdata.history.${item[1]}`} /> : item[1]}</div></div></div>)}
            </div>
        </div>
    )
}

export const CustomTableWithHeader = (props) => {
    let data = props.data || [];
    let isLang = false;
    if (props.isLang) isLang = true;
    if (data.length > 0) {
        return (
            <div style={{ display: props.display ? props.display : "block" }} className={classes.PageTableSection}>
                {data.map((item, index) => {
                    return <CustomTableWithHeaderRow isLang={isLang} isFirst={(index === 0) ? true : false} data={Object.entries(item)} />
                })}

            </div>
        )
    } else return (<div />)
}